/**
 * Цвета тем — ОДНА таблица на программу и сервер.
 *
 * Клиент красит ими интерфейс, сервер подставляет их в манифест приложения:
 * цвет строки заголовка установленного окна берётся оттуда, ещё до запуска
 * программы. Держи таблицу в двух местах — и однажды окно откроется одним
 * цветом, а шапка внутри окажется другой.
 */
export const THEME_COLORS = {
    teal: { accent: '#0F6B66', accentDark: '#0B4E4A' },
    blue: { accent: '#1D5C8C', accentDark: '#123D5E' },
    gray: { accent: '#52525B', accentDark: '#27272A' },
    /*
     * Шалфейный и «пыльная роза» пришли на место ЯРКИХ зелёной и бордовой.
     *
     * Дело не только во вкусе. Насыщенный зелёный акцента спорил с зелёным
     * статусом «готово», а бордовый — с красным «просрочено»: на пёстрой теме
     * список заказов переставал читаться взглядом, ради чего статусные цвета и
     * существуют (§8). Приглушённая пара такого спора не создаёт.
     */
    sage: { accent: '#5A7360', accentDark: '#3C4F41' },
    rose: { accent: '#96625D', accentDark: '#6B4844' },
    plum: { accent: '#75577A', accentDark: '#513C55' },
    coffee: { accent: '#6F5A4B', accentDark: '#4B3D33' },
    ink: { accent: '#4C5578', accentDark: '#343A53' },
    /*
     * Своя тема: настоящие цвета — в настройках (`colors.theme`), см.
     * resolveThemePair. Здесь только запасная пара на случай, если своя тема
     * выбрана, а цвета потерялись: серая, спокойнее любой яркой догадки.
     */
    custom: { accent: '#52525B', accentDark: '#27272A' },
};
/**
 * Прежние названия тем → нынешние.
 *
 * Тема лежит в базе строкой, а не перечислением: у лаборатории, выбравшей
 * зелёную или бордовую, там так и осталось прежнее слово. Без этой таблицы
 * оно стало бы «неизвестным именем», и при следующем запуске программа молча
 * открылась бы бирюзовой — как будто настройку кто-то сбросил.
 */
const LEGACY_THEME_NAMES = {
    green: 'sage',
    wine: 'rose',
};
/** Название темы, годное сегодня. Неизвестное — бирюзовая, как при первом запуске. */
export function resolveThemeName(name) {
    const key = name ?? '';
    if (key in THEME_COLORS)
        return key;
    return LEGACY_THEME_NAMES[key] ?? 'teal';
}
/** Цвета темы по имени. Неизвестное имя — бирюзовая, как при первом запуске. */
export function themeColors(name) {
    return THEME_COLORS[resolveThemeName(name)];
}
//# sourceMappingURL=theme-colors.js.map